import PropTypes from 'prop-types';

export const ctaShape = PropTypes.shape({
  label: PropTypes.string,
  aria_label: PropTypes.string,
  url: PropTypes.string,
});

export const imageShape = PropTypes.shape({
  desktop: PropTypes.shape({}),
  mobile: PropTypes.shape({}),
});

export const contentShape = PropTypes.shape({
  title: PropTypes.string,
  copy: PropTypes.string,
  fine_copy: PropTypes.string,
  image: imageShape,
  cta: ctaShape,
});

export const sectionShape = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  thumb_image: PropTypes.string,
  layout: PropTypes.string,
  order_id: PropTypes.number,
  hide_section: PropTypes.bool,
  content: contentShape,
});

export const carouselConfigShape = PropTypes.shape({
  section_title: PropTypes.string,
  section_intro: PropTypes.string,
  initial_active_index: PropTypes.number,
  sections: PropTypes.arrayOf(sectionShape),
});
